import React, { useContext, createContext } from 'react';

import { MenuItem, Radio } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import HeaderLabelIcons from './HeaderLabelIcons';

const SortOptionContext = createContext();

function Select() {
  const { isOrdered } = useContext(SortOptionContext);
  return <Radio color="primary" checked={isOrdered} />;
}

function SortLabel({ children }) {
  const { isOrdered } = useContext(SortOptionContext);

  return <StyledTypography color={isOrdered ? 'primary' : 'textSecondary'}>{children}</StyledTypography>;
}

function SortLabelIcons() {
  const { isOrdered, optionKey, orderBy, order } = useContext(SortOptionContext);

  return isOrdered ? <HeaderLabelIcons headCell={{ id: optionKey }} orderBy={orderBy} order={order} /> : null;
}

function HeaderSortOption({ optionKey, orderBy, order, createSortHandler, children }) {
  const isOrdered = orderBy === optionKey;
  const onClick = createSortHandler(optionKey);
  const contextValue = { isOrdered, orderBy, order, optionKey };
  return (
    <SortOptionContext.Provider value={contextValue}>
      <SortOptionContainer>
        <MenuItem onClick={onClick}>{children}</MenuItem>
      </SortOptionContainer>
    </SortOptionContext.Provider>
  );
}

HeaderSortOption.Select = Select;
HeaderSortOption.SortLabel = SortLabel;
HeaderSortOption.SortLabelIcons = SortLabelIcons;

export const SortOptionContainer = styled.div`
  z-index: 5;
  position: relative;
`;

export default HeaderSortOption;
